import React, {useEffect} from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {Autocomplete} from "@mui/material";
import { TextField } from "@mui/material";
import {word} from "../../word.js";
import Account from "../../helpers/Account.js";
const {profession} = Account.getData()

const DropDownTask = ({ item, index, setFormData, submitted, limit_data, forMe, setForMe }) => {
    const animatedComponents = makeAnimated();
    const options = React.useMemo(() => [...(limit_data[item.option] || [])], [limit_data, item.option]);
    const handleSelectChange = (list) => {
        let selectAllIndex = list?.findIndex((el) => el.value === "*");
        let updatedValue = selectAllIndex !== -1 ? [...limit_data[item.option]] : list || [];

        setFormData((prevForm) =>
            prevForm.map((el, i) => (i === index ? { ...el, value: updatedValue, valid: updatedValue.length > 0 } : el))
        );
    };

    return (
        <div
            key={index}
            className={!item.valid && submitted ? "input-validation input-validation-valid" : "input-validation"}
        >
            {item.key === "accountant" ? (
                <Select
                    isDisabled={forMe}
                    closeMenuOnSelect={false}
                    value={item.value}
                    components={animatedComponents}
                    options={options}
                    className={!item.valid && submitted ? "error-select" : ""}
                    onChange={handleSelectChange}
                    placeholder={word[item.key]}
                    isMulti
                />
            ) : (
                <Autocomplete
                    key={index}
                    loading={options.length === 0}
                    options={options}
                    onChange={(e, value) => {
                        setFormData((prevForm) =>
                            prevForm.map((el, i) => (i === index ? { ...el, value: value?.url || "", valid: !!value } : el))
                        );
                        if (item.key === "manager" && value && profession === "manager") {
                            setForMe(true);
                        } else if (item.key === "manager" && !value) {
                            setForMe(false);
                        }
                    }}
                    getOptionLabel={(option) =>
                        item.key === "manager" ? `${option.user.first_name} ${option.user.last_name}` : option.name
                    }
                    getOptionKey={(option) => option.id}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            error={!item.valid && submitted}
                            label={word[item.key]}
                            variant="outlined"
                            fullWidth
                        />
                    )}
                />
            )}
            {!item.valid && submitted && <div className="validation valid-center">{word[item.errorMessage]}</div>}
        </div>
    );
};

export default DropDownTask;
